export default "__VITE_ASSET__Ch82kyT2__"